import { Middlewares } from "@/app/shared/services/app-router/middlewares";
import Guard from "vue-router-multiguard";

export default [
    {
        path: "/account-mailers",
        name: "AccountList",
        component: () => import("./views/accountsList.vue"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/account-mailers/create",
        name: "CreateAccount",
        component: () => import("./views/updateAccount.vue"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
    {
        path: "/account-mailers/update/:id",
        name: "UpdateAccount",
        component: () => import("./views/updateAccount.vue"),
        beforeEnter: Guard([Middlewares.authRequired, Middlewares.adminAccess]),
    },
];
